import { Component, OnDestroy, OnInit, ViewChild, signal } from '@angular/core';
import { Table } from 'primeng/table';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Instancia } from '../../../../types/Instancia.type';
import { Pesagem } from '../../../../types/Pesagem.type';

@Component({
  selector: 'app-pesagem',
  templateUrl: './pesagem.component.html',
  styleUrl: './pesagem.component.css'
})
export class PesagemComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table!: Table;

  pesagens: Pesagem[] = [];
  totalRecords: number = 0;
  loading: boolean = false
  loadingSincronizar: boolean = false;
  pesagemSelecionada: Pesagem = {} as Pesagem;
  visible: boolean = false;

  count = signal(10); // Inicializa o contador com 10
  intervalId: any;

  iniciaContador() {
    this.intervalId = setInterval(() => {
      if (this.count() > 0) {
        this.count.set(this.count() - 1);
      } else {
        this.recarregar();
        this.count.set(10); // Reinicia o contador
      }
    }, 1000); // Atualiza a cada segundo
  }

  status: any[] = [ {name: 'Integrado', value: 'Integrado' }
                  , {name: 'Enviando ao PIMS', value: 'Enviando ao PIMS'}
                  , {name: 'Aguardando Pesagem', value: 'Aguardando Pesagem'}
                  , {name: 'Enviando ao ERP', value: 'Enviando ao ERP'}
                  , {name: 'Erro', value: 'Erro'}
                  , {name: 'Gerando Certificado', value: 'Gerando Certificado'}
                  , {name: 'Cancelado', value: 'Cancelado'}
                ]

  instancias: Instancia[] = [{id: 'VALE', nome: 'VALE'}, {id: 'UCP', nome: 'UCP'}, {id: 'UVP', nome: 'UVP'} ]

  private readonly busca$ = new Subject<string>();
  private readonly subscriptions = new Subscription();

  constructor(private integradorService: IntegradorService, private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.busca$.pipe(debounceTime(400), distinctUntilChanged()).subscribe((valor) => {
        this.table.filterGlobal(valor, 'contains');
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onBuscaInput(valor: string){
    this.busca$.next(valor);
  }

  sincronizarOrdens(){
    this.loadingSincronizar = true
    this.integradorService.sincronizarPesagens().subscribe({
      next: () => {
        this.recarregar();
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao sincronizar: " + error.error.message)
      },
      complete: () => {
        this.loadingSincronizar = false
      }
    })
  }

  onLazyLoad(event: any){
    this.loading = true;

    const rows = event.rows || 20;
    const page = (event.first ?? 0) / rows;
    const busca = event.globalFilter || undefined;

    const sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField;
    const sortDirection = event.sortOrder === -1 ? 'desc' : 'asc';

    const filtroInstancias = event.filters?.['instancia'];
    const instancias = Array.isArray(filtroInstancias) ? filtroInstancias[0]?.value : filtroInstancias?.value;

    const filtroStatus = event.filters?.['fgStatusInteg'];
    const statusInteg = Array.isArray(filtroStatus) ? filtroStatus[0]?.value : filtroStatus?.value;

    this.integradorService.getPesagens(page, rows, busca, instancias, statusInteg, sortField, sortDirection).subscribe({
      next: (data) => {
        this.pesagens = data.content;
        this.totalRecords = data.page?.totalElements ?? data.totalElements ?? 0;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message)
        console.log(error)
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  recarregar(){
    if (this.table) {
      this.table.first = 0;
      this.onLazyLoad({
        first: 0,
        rows: this.table.rows || 20,
        sortField: this.table.sortField,
        sortOrder: this.table.sortOrder,
        filters: this.table.filters,
        globalFilter: this.table.filters?.['global'] ? (this.table.filters['global'] as any).value : null
      });
    } else {
      this.onLazyLoad({ first: 0, rows: 20 });
    }
  }

  getStatus(status: string): string{

    let stt = '';

    switch(status){
      case "IT":
        stt = "Integrado";
        break;
      case "IP":
        stt = "Enviando ao PIMS";
        break;
      case "AP":
        stt = "Aguardando Pesagem";
        break;
      case "IE":
        stt = "Enviando ao ERP";
        break;
      case "ER":
        stt = "Erro";
        break;
    }

    return stt;

  }

  getSeverity(status: string): string {
    let stt = '';

    switch(status){
      case "Integrado":
        stt = "success";
        break;
      case "Erro":
        stt = "danger";
        break;
      default:
        stt = "info";
        break;
    }

    return stt;
  }

  getIcon(status: string): string {
    let stt = '';

    switch(status.toLowerCase()){
      case "integrado":
        stt = "pi pi-check";
        break;
      case "erro":
        stt = "pi pi-times";
        break;
      case "enviando ao pims":
        stt = "pi pi-arrow-down-left";
        break;
      case "aguardando pesagem":
        stt = "pi pi-history"
        break;
      case "enviando ao erp":
          stt = "pi pi-arrow-up-right";
          break;
      case "cancelado":
         stt = "pi pi-ban";
         break;
      case "gerando certificado":
        stt = "pi pi-file-o" ;
        break;
      case "pesando":
          stt = "pi pi-truck"
          break;
      default:
        stt = "pi pi-info";
        break;
    }

    return stt;
  }

  toInt(texto: string): number{

    return parseInt(texto);
  }

  exibirJson(pesagem: Pesagem){
    this.visible = true;
    this.pesagemSelecionada = pesagem;

    console.log(this.pesagemSelecionada)
  }


}
